var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheartericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 20.8333C4.1665 20.8333 10.4165 14.5833 10.4165 4.16663",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8335 20.8333C45.8335 20.8333 39.5835 14.5833 39.5835 4.16663",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8332 4.16663C20.8332 13.3333 13.3332 20.8333 4.1665 20.8333",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 4.16663C29.1665 13.3333 36.6665 20.8333 45.8332 20.8333",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 20.8334C4.1665 20.8334 8.33317 25 8.33317 31.25",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8332 20.8334C45.8332 20.8334 41.6665 25 41.6665 31.25",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 31.25H33.3332",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 45.8334V43.75C4.1665 42.645 4.60549 41.5852 5.38689 40.8038C6.16829 40.0224 7.2281 39.5834 8.33317 39.5834H16.6665C17.7716 39.5834 18.8314 40.0224 19.6128 40.8038C20.3942 41.5852 20.8332 42.645 20.8332 43.75V45.8334",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 45.8334V43.75C29.1665 42.645 29.6055 41.5852 30.3869 40.8038C31.1683 40.0224 32.2281 39.5834 33.3332 39.5834H41.6665C42.7716 39.5834 43.8314 40.0224 44.6128 40.8038C45.3942 41.5852 45.8332 42.645 45.8332 43.75V45.8334",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheartericon);
export default __webpack_public_path__ + "static/media/thearter icon.0e80d84cb82c442df9ab892da857f43d.svg";
export { ForwardRef as ReactComponent };